import { Spinner } from 'featureSliced/entities/Spinner'
import { useTranslations } from '../../featureSliced/shared/hooks/useTranslations'
import { MessageContainerNoReceipt, ReceiptLoadingContainer } from './styled'

export const ReceiptLoading = () => {
  const t = useTranslations()
  return (
    <ReceiptLoadingContainer>
      <h2>{t('receipt.receiptIsLoading')}</h2>
      <Spinner type="alternate" />
    </ReceiptLoadingContainer>
  )
}
